import { SentryConfig } from './SentryConfig';

export type TelemetryConfigs = {
  sentry?: SentryConfig;
};

const empty = (): TelemetryConfigs => ({
  sentry: {
    dsn: '',
    enabled: false,
    environment: '',
    tracesSampleRate: 0,
  },
});

export const TelemetryConfigs = {
  empty,
};
